export const TranshipmentTransferHandler = {
  getSelectedTranshipmentId(context) {
    return context.$store.getters.selectedTranshipmentId;
  },
  getSelectedTranshipmentToTransferId(context) {
    return context.$store.getters.selectedTranshipmentToTransferId;
  },
  setSelectedTranshipmentId(context, transhipmentId) {
    context.$store.commit('SET_SELECTED_TRANSHIPMENT_ID', transhipmentId);
  },
  setSelectedTranshipmentToTransferId(context, transhipmentId) {
    context.$store.commit('SET_TRANSHIPMENT_TO_TRANSFER_ID', transhipmentId);
  }
};

const state = {
  isTranshipmentDeliverersLoading: false,
  selectedTranshipmentId: null,
  selectedTranshipmentToTransferId: null
};

const getters = {
  isTranshipmentDeliverersLoading: (state) => {
    return state.isTranshipmentDeliverersLoading;
  },
  selectedTranshipmentId: (state) => {
    return state.selectedTranshipmentId;
  },
  selectedTranshipmentToTransferId: (state) => {
    return state.selectedTranshipmentToTransferId;
  }
};

const mutations = {
  SET_SELECTED_TRANSHIPMENT_ID: (state, transhipmentId) => {
    state.selectedTranshipmentId = transhipmentId;
  },
  SET_TRANSHIPMENT_TO_TRANSFER_ID: (state, transhipmentId) => {
    state.selectedTranshipmentToTransferId = transhipmentId;
  }
};

export default {
  state,
  getters,
  mutations
};
